<script setup>
import notification from "@/utils/plugins/NotificationService";
/* eslint-disable */
// Components
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import HolidayStatusConfirmDialog from "@/components/shared/HolidayStatusConfirmDialog.vue";
import HolidayGantt from "./HolidayGantt";
import { filterVacationPlanning, approvedVacationPlanningDays, vacationPlanningDays, loadVacationPlanning } from "./holidayPlanning";
import { canChangeHolidayStatus, statusActions, statusLabels } from '../team-holidays/teamHolidayStatus';
import HeaderTitle from "@/components/layout/HeaderTitle.vue";

// Services
import HolidayService from '@/api/services/holiday.service';
import EmployeeService from '@/api/services/employee.service';
import Common from '@/api/services/common.service';
import ResourceService from "@/api/services/resource.service";

import moment from "moment";
import { computed, h, onMounted, ref, shallowRef } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";
import { useRouter } from "vue-router";
import EmployeeAvatar from "@/components/shared/EmployeeAvatar.vue";

import ModalReportHolidays from "@/views/holidays/ModalReportHolidays.vue";


const authStore = useAuthStore();
const uiStore = useUiStore();
const router = useRouter()


const employeeName = ref(null);
const selectedEmployeeId = ref(null);
const employeeOptions = ref([]);
const selectedFromDate = ref(null);
const selectedToDate = ref(null);
const defaultToDate = ref(null);

const statusOptions = Object.entries(statusLabels).map(([value, label]) => ({ value, label }));

const statusClassById = (status) => {
  const map = { pending: 'holiday-status--pending', approved: 'holiday-status--approved', rejected: 'holiday-status--rejected', cancelled: 'holiday-status--cancelled' }
  return map[status] ?? ''
}

const statusClass = (label) => {
  if (label === 'Pendiente') return 'holiday-status--pending'
  if (label === 'Aprobada') return 'holiday-status--approved'
  if (label === 'Rechazada') return 'holiday-status--rejected'
  if (label === 'Cancelada') return 'holiday-status--cancelled'
  return ''
}

// Transiciones válidas según la máquina de estados:
//   PENDING   → APPROVED | REJECTED
//   APPROVED  → CANCELLED
//   REJECTED, CANCELLED → terminales (sin transiciones)
const filteredStatusOptions = (currentStatus) => {
  switch (currentStatus) {
    case 'pending':
      return statusOptions.filter(o => o.value === 'pending' || o.value === 'approved' || o.value === 'rejected')
    case 'approved':
      return statusOptions.filter(o => o.value === 'approved' || o.value === 'cancelled')
    default:
      return statusOptions.filter(o => o.value === currentStatus)
  }
}

const isTerminalStatus = (status) => status === 'rejected' || status === 'cancelled'


const customPrefix = shallowRef({
  render() {
    return h('img', {
      src: '/calendar-blue.svg',
      style: 'width: 16px; height: 16px; margin-right: 10px;',
    });
  },
})
const selectedStatusFilter = ref(null);
const planningStatusFilter = ref('approved');
const selectedDepartmentFilter = ref({});
const departmentsOriginal = ref([]);
const showStatusConfirmationModal = ref(false);
const confirmingStatus = ref(false);
// const newStatusInfo = ref({
//   newStatus: null,
//   holidayData: null
// });

// Tabla
const holidays = ref([]);
const selectedHoliday = ref({});
const selectedIndex = ref(0);

const totalResults = ref(0);
const page = ref(1);
const itemsPerPage = ref(100);
const params = ref({});
const toDateDisabledDates = ref({
  to: null
});
const showGantt = ref(false);
const datesAutoFilled = ref(false);
const textButton = ref("Plan de producción");
const vacationPlanningData = ref([]);
const totalVacations = ref(0);

const yearsExercise = ref([]);

// Estado para controlar la visibilidad del diálogo
const dialogVisible = ref(false)

// Manejador para cerrar el diálogo
const handleClose = (done) => {
  dialogVisible.value = false
  done()
}

// Manejador para el evento emitido desde el componente hijo
const handleCloseDialog = () => {
  dialogVisible.value = false
}

// Variable reactiva para controlar la visibilidad del modal
const modalVisible = ref(false);

// Función para abrir el modal al hacer clic en el botón
const openModal = () => {
  modalVisible.value = true;
};

const user = computed(() => {
  return authStore.getUserLogged;
})

const departments = computed(() => {
  return [
    { id: 0, name: 'TODOS' },
    ...departmentsOriginal.value
  ];
})

const vacationPlanning = computed(() => {
  let fromDate = selectedFromDate.value;
  let toDate = selectedToDate.value;


  if (selectedFromDate.value === null && selectedToDate.value === null) {
    fromDate = moment().format('YYYY-MM-DD 00:00:00');
    toDate = moment(fromDate).add(3, 'months').format('YYYY-MM-DD 23:59:59');
  }

  if (selectedFromDate.value !== null && selectedToDate.value === null) {
    fromDate = selectedFromDate.value;
    toDate = moment(fromDate).add(3, 'months').format('YYYY-MM-DD 23:59:59');
  }

  if (selectedFromDate.value === null && selectedToDate.value !== null) {
    fromDate = moment(toDate).subtract(3, 'months').format('YYYY-MM-DD 00:00:00');
    toDate = selectedToDate.value;
  }

  // if (department) {
  //   params.value['department'] = selectedDepartmentFilter.value.value;
  // } else {
  //   delete params.value['department'];
  // }
  if (selectedDepartmentFilter.value && selectedDepartmentFilter.value.value !== 0) {
    params.value['department'] = selectedDepartmentFilter.value.value;
  } else {
    delete params.value['department'];
  }

  return {
    'vacationPlanning': filterVacationPlanning(vacationPlanningData.value, employeeName.value),
    'fromDate': fromDate,
    'toDate': toDate
  };
})

const planningPendingDays = computed(() => vacationPlanningDays(vacationPlanning.value.vacationPlanning, 'pending'));
const planningTotalVacations = computed(() => approvedVacationPlanningDays(vacationPlanning.value.vacationPlanning));

onMounted(() => {
  if (ifIsInArray(user.value.roles, 'ROLE_ADMIN')) {
    // Inicialmente buscamos las vacaciones con el estado 'Pendiente'
    selectedStatusFilter.value = 'pending';
    params.value['status'] = selectedStatusFilter.value;
    params.value['order[employee.name]'] = 'ASC';
    params.value['order[fromDate]'] = 'DESC';
    params.value['employee.active'] = true;
    getDepartments();
    getEmployeeOptions();
    getYearsExercise();
    getHolidays();
    getVacationPlanning();
  }
})

const getEmployeeOptions = async () => {
  uiStore.startLoading();
  try {
    const response = await EmployeeService.getEmployees({
      'order[name]': 'asc',
      active: 1,
      page: 1,
      itemsPerPage: 999999,
    });
    employeeOptions.value = (response.data['hydra:member'] || []).map(employee => ({
      id: employee.id,
      name: employee.fullName || [employee.name, employee.lastName].filter(Boolean).join(' '),
    })).sort((a, b) => a.name.localeCompare(b.name, 'es'));
  } catch {
    notification.addNotification({
      title: 'Vacaciones',
      message: 'Error al obtener los empleados del selector',
      type: 'error',
    });
  } finally {
    uiStore.stopLoading();
  }
};

const changeEmployeeFilter = (id) => {
  selectedEmployeeId.value = id || null;
  employeeName.value = employeeOptions.value.find(employee => employee.id === id)?.name || null;
  search();
};

const search = () => {
  page.value = 1;
  getHolidays();
  getVacationPlanning()
}

const disabledDate = (time) => {
  if (selectedFromDate.value) {
    defaultToDate.value = selectedFromDate.value;
    let date = new Date(selectedFromDate.value);
    return time.getTime() <= date.setDate(date.getDate() - 1);
  } else {
    return time.getTime() <= Date.now();
  }
}

/* Obtiene las vacaciones */
const getHolidays = async () => {
  delete params.value['toDate[before]'];
  delete params.value['fromDate[after]'];
  delete params.value['toDate'];
  delete params.value['fromDate'];
  delete params.value['department'];
  await uiStore.startLoading();
  // if (!showGantt.value) {
  if (selectedStatusFilter.value !== null) {
    params.value['status'] = selectedStatusFilter.value
  } else {
    delete params.value['status'];
  }
  if (employeeName.value && employeeName.value.length > 0) {
    params.value.orSearch_fullName = employeeName.value
  } else {
    delete params.value.orSearch_fullName;
  }

  if (selectedDepartmentFilter.value && selectedDepartmentFilter.value.value !== 0) {
    params.value['employee.job.department.id'] = selectedDepartmentFilter.value.value;
  } else {
    delete params.value['employee.job.department.id'];
  }
  // params.value['order[fromDate]'] = 'DESC'
  params.value.page = page.value;
  params.value.itemsPerPage = itemsPerPage.value;
  if (selectedFromDate.value) {
    params.value['fromDate[after]'] = moment(selectedFromDate.value).format('YYYY-MM-DD 00:00:00')
  }
  if (selectedToDate.value) {
    params.value['toDate[before]'] = moment(selectedToDate.value).format('YYYY-MM-DD 23:59:59')
  }
  try {
    const res = await HolidayService.getHolidays(params.value);
    // Inicializamos el estado de cada registro de vacaciones
    holidays.value = res.data['hydra:member'];
    holidays.value.forEach(holiday => {
      holiday._confirmedStatus = holiday.status
    });
    totalVacations.value = holidays.value
      .filter(holiday => holiday.status === 'approved')
      .reduce((acc, holiday) => {
        acc += holiday.daysConsumed;
        return acc;
      }, 0);
    totalResults.value = res.data['hydra:totalItems'];
  } catch {
    notification.addNotification({
      title: 'Vacaciones',
      message: 'Error al obtener el listado de vacaciones',
      type: 'error',
      duration: 6000
    });
  } finally {
    uiStore.stopLoading();
  }
  // }

}

let planningLoadVersion = 0;
const getVacationPlanning = async () => {
  const version = ++planningLoadVersion;
  uiStore.startLoading();
  // params.value.approved = 1;
  delete params.value.page;
  delete params.value.itemsPerPage;

  delete params.value['toDate[before]'];
  delete params.value['fromDate[after]'];

  delete params.value['employee.job.department.id'];

  let fromDate = selectedFromDate.value;
  let toDate = selectedToDate.value;

  if (selectedFromDate.value === null && selectedToDate.value === null) {
    fromDate = moment().format('YYYY-MM-DD 00:00:00');
    toDate = moment(fromDate).add(3, 'months').format('YYYY-MM-DD 23:59:59');
  }

  if (selectedFromDate.value !== null && selectedToDate.value === null) {
    fromDate = selectedFromDate.value;
    toDate = moment(fromDate).add(3, 'months').format('YYYY-MM-DD 23:59:59');
  }

  if (selectedFromDate.value === null && selectedToDate.value !== null) {
    fromDate = moment(toDate).subtract(3, 'months').format('YYYY-MM-DD 00:00:00');
    toDate = selectedToDate.value;
  }

  // params.value.toDate = toDate;
  // params.value.fromDate = fromDate;

  if (selectedDepartmentFilter.value && selectedDepartmentFilter.value.value !== 0) {
    params.value['department'] = selectedDepartmentFilter.value.value;
  } else {
    delete params.value['department'];
  }

  const paramsVacationPlanning = {
    fromDate: fromDate,
    toDate: toDate,
    department: selectedDepartmentFilter.value.value,
    ...(selectedEmployeeId.value ? { employeeId: selectedEmployeeId.value } : {}),
    'order[employee.name]': 'ASC',
    'order[fromDate]': 'DESC'
  }


  await loadVacationPlanning(
    params => HolidayService.getVacationPlanning(params, { silent: true }),
    paramsVacationPlanning,
    planningStatusFilter.value,
  ).then((employees) => {
      if (version !== planningLoadVersion) return;
      vacationPlanningData.value = employees;
    })
    .catch((error) => {
      if (version !== planningLoadVersion) return;
      vacationPlanningData.value = [];
      notification.addNotification({
        title: 'Vacaciones',
        message: error.response?.status === 403 ? 'No tienes permiso para consultar este plan.'
          : error.response?.status === 400 ? 'La API no admite el filtro de estados seleccionado.'
          : 'No se pudo cargar el plan. Comprueba que la API devuelve vacaciones con id y estado.',
        type: 'error',
      });
    })
    .finally(() => uiStore.stopLoading());

}

const getYearsExercise = async () => {
  uiStore.startLoading();
  await HolidayService.getYearsExercise()
    .then((res) => {
      yearsExercise.value = res.data;
      uiStore.stopLoading();
    })
    .catch(() => {
      uiStore.stopLoading();
    })
}


/* Incluye un filtro según la fecha de inicio de las vacaciones */
const filterHolidaysFromDate = () => {

  if (!showGantt.value) {
    if (selectedFromDate.value != null) {
      if (selectedToDate.value == null) {
        // Caso 2)
        delete params.value['toDate[before]'];
        delete params.value['fromDate[after]'];
        params.value['fromDate[after]'] = moment(selectedFromDate).format('YYYY-MM-DD 00:00:00')

      } else {
        // caso 4)
        delete params.value['fromDate[after]'];
        delete params.value['toDate[before]'];
        params.value['fromDate[after]'] = moment(selectedToDate.value).format('YYYY-MM-DD 23:59:59')
        params.value['toDate[before]'] = moment(selectedFromDate.value).format('YYYY-MM-DD 00:00:00')
      }
    }
  } else {
    if (!selectedToDate.value) {
      // Caso 1)
      delete params.value['toDate[before]'];
      delete params.value['fromDate[after]'];
    } else {
      // Caso 3)
      delete params.value['toDate[before]'];
      delete params.value['fromDate[after]'];
      params.value['toDate[before]'] = moment(selectedToDate.value).format('YYYY-MM-DD 00:00:00')
    }

    page.value = 1;
    getHolidays();
  }

}


/* Incluye un filtro según la fecha de fin de las vacaciones */
const filterHolidaysToDate = () => {
  if (!showGantt.value) {
    if (selectedToDate.value != null) {
      if (selectedFromDate.value == null) {
        // Caso 3)
        delete params.value['fromDate[after]'];
        delete params.value['toDate[before]'];
        params.value['toDate[before]'] = moment(selectedToDate.value).format('YYYY-MM-DD 23:59:59')
      } else {
        // Caso 4)
        delete params.value['fromDate[after]'];
        params.value['fromDate[after]'] = moment(selectedToDate.value).format('YYYY-MM-DD 23:59:59')
        params.value['toDate[before]'] = moment(selectedFromDate.value).format('YYYY-MM-DD 00:00:00')
      }
    } else {
      if (selectedFromDate.value == null) {
        // Caso 1)
        delete params.value['toDate[after]'];
        delete params.value['toDate[before]'];
        delete params.value['fromDate[before]'];
        delete params.value['fromDate[after]'];
      } else {
        // Caso 2)
        delete params.value['toDate[after]'];
        delete params.value['toDate[before]'];
        delete params.value['fromDate[before]'];
        params.value['fromDate[after]'] = moment(selectedFromDate.value).format('YYYY-MM-DD 00:00:00')
      }
    }

    page.value = 1;
    getHolidays();
  } else {
    getVacationPlanning();
  }
}

/* Transita a una vista en la que se muestran las vacaciones del empleado en cuestión */
const openHolidayDetails = (holidayInfo) => {
  const EmployeeID = getIDFromUriID(holidayInfo.employee['@id']);
  router.push(`/holidays/${EmployeeID != null ? EmployeeID : 'new'}`)
}

/* Obtiene el ID de la URI pasada por párametro */
const getIDFromUriID = (uriID) => {
  if (uriID.indexOf('/') > -1) {
    let EmployeeID = uriID.split('/');
    return EmployeeID[EmployeeID.length - 1];
  }
  return null;
}


/* Evento que se ejecuta cuando cambia el selector de estado de unas vacaciones (desde la tabla) */
const specificHolidayStatusChange = (index) => {
  selectedIndex.value = index
  selectedHoliday.value = holidays.value[index]
  showStatusConfirmationModal.value = true
}

const planningHolidayStatusChange = (row, status) => {
  if (confirmingStatus.value || showStatusConfirmationModal.value || !canChangeHolidayStatus(row.holiday, status)) return;
  selectedIndex.value = null;
  selectedHoliday.value = { ...row.holiday, employee: row.employee, status, _confirmedStatus: row.holiday.status };
  showStatusConfirmationModal.value = true;
}

const closeStatusConfirmationModal = () => {
  if (confirmingStatus.value || !showStatusConfirmationModal.value) return
  if (selectedIndex.value !== null) holidays.value[selectedIndex.value].status = selectedHoliday.value._confirmedStatus
  showStatusConfirmationModal.value = false
  selectedHoliday.value = {}
  selectedIndex.value = 0
}

const acceptStatusConfirmationModal = async () => {
  if (confirmingStatus.value || !showStatusConfirmationModal.value) return;
  const holiday = selectedHoliday.value;
  const previousStatus = holiday._confirmedStatus;
  const newStatus = holiday.status;
  if (!canChangeHolidayStatus({ ...holiday, status: previousStatus }, newStatus)) {
    closeStatusConfirmationModal();
    return;
  }
  confirmingStatus.value = true;
  uiStore.startLoading();
  let updated = false;
  try {
    const response = await HolidayService[statusActions[newStatus]](holiday.id, undefined, { silent: true });
    if (!response || !Number.isInteger(response.status) || response.status < 200 || response.status >= 300)
      throw new Error('No se pudo cambiar el estado');
    holiday._confirmedStatus = newStatus;
    notification.addNotification({ title: 'Vacaciones', message: 'Estado de vacaciones actualizado', type: 'success' });
    updated = true;
  } catch (error) {
    notification.addNotification({
      title: 'Vacaciones',
      message: error.response?.status === 403 ? 'No tienes permiso para cambiar estas vacaciones' : error.response?.status === 400 ? 'Este cambio de estado no está permitido. Actualiza las vacaciones.' : 'Error al cambiar el estado de las vacaciones',
      type: 'error',
      duration: 6000,
    });
  } finally {
    confirmingStatus.value = false;
    uiStore.stopLoading();
    closeStatusConfirmationModal();
  }
  if (updated) await Promise.all([getHolidays(), getVacationPlanning()]);
}

// eslint-disable-next-line no-unused-vars
const fromDateSelected = (selectedDate) => {
  if (selectedDate != null) {
    // Deshabilitamos como fecha de fín todos los días anteriores a la fecha de 'desde'
    selectedToDate.value = null;
    toDateDisabledDates.value.to = new Date();
    toDateDisabledDates.value.to.setDate(selectedDate.getDate() - 1);
  } else {
    toDateDisabledDates.value.to = null;
  }
}

const ifIsInArray = (userRoles, role) => {
  return Common.ifIsInArray(userRoles, role);
}
const changeBetweenHolidaysOrGantt = () => {
  showGantt.value = !showGantt.value;
  showGantt.value ? textButton.value = 'Listado Vacaciones' : textButton.value = 'Plan de producción';

  if (showGantt.value) {
    planningStatusFilter.value = 'approved';
    if (selectedFromDate.value === null && selectedToDate.value === null) {
      selectedFromDate.value = moment().format('YYYY-MM-DD');
      selectedToDate.value = moment().add(3, 'months').format('YYYY-MM-DD');
      datesAutoFilled.value = true;
    }
  } else if (datesAutoFilled.value) {
    selectedFromDate.value = null;
    selectedToDate.value = null;
    datesAutoFilled.value = false;
  }

  search();
  // getVacationPlanning();
}

const getDepartments = (searchQuery = '') => {
  //const params = {query: {name: searchQuery}};
  const params = (searchQuery.length > 0 ? { name: searchQuery } : {});
  uiStore.startLoading();
  ResourceService.getDepartments(params).then((res) => {
    departmentsOriginal.value = res.data['hydra:member'];
  }).catch(() => {
    notification.addNotification({
      message: 'Error al obtener los departamentos',
      type: 'error',
    });
  }).finally(() => {
    uiStore.stopLoading();
  }
  );
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY');
  }
  return '';
}
const formatDateTime = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm');
  }
  return '';
}

</script>

<template>
  <div v-if="user && ifIsInArray(user.roles, 'ROLE_ADMIN')" class="holidays">
    <HeaderTitle title="Talento" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/hollidays.svg" alt="">
      <div class="title-text ml-4">
        Vacaciones
      </div>
    </div>
    <el-row class="mt-2">
      <el-card class="card-search card-abs w-100 wback" body-style="padding:0">
        <div class="container-holidays">
          <!-- Empleado -->
          <div class="row">
            <div class="col-md-4 el-col-xs-24">
              <div class=" form-item label-common">
                <label class="w-100" for="holiday-employee">Empleado</label>
                <el-select id="holiday-employee" v-model="selectedEmployeeId" class="w-100" placeholder="TODOS"
                  filterable clearable no-match-text="Sin coincidencias" @change="changeEmployeeFilter">
                  <el-option v-for="employee in employeeOptions" :key="employee.id"
                    :label="employee.name" :value="employee.id" />
                </el-select>
              </div>
            </div>
            <div class="col-md-4 el-col-xs-24">
              <div class="form-item label-common">
                <label class="w-100">Departamento</label>
                <el-select v-model="selectedDepartmentFilter.value" placeholder="Todos" clearable filterable
                  @change="search">
                  <el-option v-for="item in departments" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </div>
            </div>
            <div class="col-md-4 el-col-xs-24">
              <div class="form-item label-common">
                <label class="w-100">Estado</label>
                <el-select v-if="showGantt" v-model="planningStatusFilter" placeholder="Todas" class="w-100" :class="statusClassById(planningStatusFilter)" @change="getVacationPlanning">
                  <el-option value="all" label="Todas" />
                  <el-option value="pending_approved" label="Pendientes y aprobadas" />
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"><span :class="statusClassById(item.value)">{{ item.label }}</span></el-option>
                </el-select>
                <el-select v-else v-model="selectedStatusFilter" :class="statusClassById(selectedStatusFilter)" placeholder="Todos" clearable filterable
                  @change="search">
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"><span :class="statusClassById(item.value)">{{ item.label }}</span></el-option>
                </el-select>
              </div>
            </div>
          </div>

          <!-- Fechas y estado -->
          <div class="">
            <div class="row">
              <div class="col-md-8 el-col-xs-24">
                <div class="row">
                  <div class="col-md-6 el-col-xs-24">
                    <div class=" form-item  date-picker  label-common">
                      <label class=" w-100 mb-2">Desde</label>
                      <el-date-picker :picker-options="{ firstDayOfWeek: 1 }" :prefix-icon="customPrefix"
                        @change="datesAutoFilled = false; search();" class="w-100" format="DD/MM/YYYY" type="date" v-model="selectedFromDate"
                        value-format="YYYY-MM-DD" />
                    </div>
                  </div>
                  <div class="col-md-6 el-col-xs-24">
                    <div class=" form-item  date-picker  label-common">
                      <label class="w-100 mb-2">Hasta</label>
                      <el-date-picker :default-value="defaultToDate" :disabled-date="disabledDate"
                        :picker-options="{ firstDayOfWeek: 1 }" :prefix-icon="customPrefix" @change="datesAutoFilled = false; search()"
                        class="w-100" format="DD/MM/YYYY" type="date" v-model="selectedToDate"
                        value-format="YYYY-MM-DD" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1 el-col-xs-24">
                <div class="d-flex justify-content-end align-content-end">
                  <div class="col-md-7 el-col-xs-24">
                    <button class="btn btn_yellow btn-search btn-new" @click="search()">
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </el-row>
    <el-row class="buttons-holiday-admin" align="middle">
      <button type="button" class="btn btn_red holiday-toolbar-button"
        @click="changeBetweenHolidaysOrGantt">
        {{ textButton }}
      </button>
      <button type="button" class="btn btn_red holiday-toolbar-button" @click="dialogVisible = true">
        Días Pendientes
      </button>
      <el-dialog v-model="dialogVisible" width="90%" style="max-width: 700px;" :before-close="handleClose" :center="true" :lock-scroll="true"
        :show-close="false" :modal-class="'no-scroll-dialog'" class="el-dialog">
        <ModalReportHolidays :departments="departments" :years-exercise="yearsExercise" v-if="dialogVisible"
          @close-dialog="handleCloseDialog" />
      </el-dialog>


      <div class="total-vacations">
        <template v-if="showGantt">{{ planningTotalVacations }} días aprobados · {{ planningPendingDays }} pendientes</template>
        <template v-else>{{ totalVacations }} días de vacaciones aprobadas</template>
      </div>
    </el-row>


    <!-- Tabla -->
    <div v-if="!showGantt" class="table table-not-mobile holidays-table">
      <div v-if="holidays && holidays.length > 0">
        <table>
          <colgroup>
            <col class="holiday-name-column">
            <col class="holiday-request-column">
            <col class="holiday-date-column">
            <col class="holiday-date-column">
            <col class="holiday-year-column">
            <col class="holiday-days-column">
            <col>
            <col class="holiday-status-column">
          </colgroup>
          <thead>
            <tr>
              <th class="text-left">Nombre</th>
              <th>Solicitud</th>
              <th>Desde</th>
              <th>Hasta</th>
              <th>Ejercicio</th>
              <th>Días</th>
              <th>Responsable</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody v-if="holidays && holidays.length">
            <tr v-for="(holiday, index) in holidays" :key="index">
              <td class="pointer" @click="openHolidayDetails(holiday)">
                <div class="row-table-image-name-link justify-content-start holiday-employee">
                  <EmployeeAvatar :employee="holiday.employee" />
                  <span>{{ holiday.employee.name }} {{ holiday.employee.lastName }}</span>
                </div>
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{ formatDateTime(holiday.timestamp) }}
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{ formatDate(holiday.fromDate) }}
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{ formatDate(holiday.toDate) }}
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{ holiday.yearExercise }}
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{ holiday.daysConsumed }}
              </td>
              <td class="pointer" @click="openHolidayDetails(holiday)">
                {{
                  (holiday.employee.teamManager != null ? holiday.employee.teamManager.name + ' ' +
                    holiday.employee.teamManager.lastName : '--')
                }}
              </td>
              <td>
                <div class="holiday-select form-item">
                  <el-select v-model="holiday.status" placeholder="Estado" :class="statusClassById(holiday.status)"
                    :disabled="isTerminalStatus(holiday.status)"
                    @change="specificHolidayStatusChange(index)">
                    <el-option v-for="item in filteredStatusOptions(holiday.status)" :key="item.value" :label="item.label"
                      :value="item.value">
                      <span :class="statusClass(item.label)">{{ item.label }}</span>
                    </el-option>
                    <template #tag>
                      <el-tag :style="{ color: 'blue' }" />
                    </template>
                  </el-select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado vacaciones según los filtros especificados...</h5>
      </div>
      <SharedElementPagination class="pagination" v-model:current-page="page"
        :total="totalResults" v-model:page-size="itemsPerPage" @change="page = $event; getHolidays()" show-always />
    </div>
    <div v-else>
      <holiday-gantt actionable :vacation-planning="vacationPlanning.vacationPlanning" :from-date="vacationPlanning.fromDate"
        :to-date="vacationPlanning.toDate" @status-change="planningHolidayStatusChange" />
    </div>
    <div v-if="!showGantt" class="table-mobile">
      <div v-if="holidays && holidays.length > 0">
        <div v-for="(holiday, index) in holidays" :key="index">
          <el-row class="mt-4">
            <el-card class="card-holiday-item" @click="openHolidayDetails(holiday)">
              <div class="row d-flex">
                <div class="el-col-xs-24 d-flex align-items-center gap-2 mb-1 holiday-employee">
                  <EmployeeAvatar :employee="holiday.employee" />
                  <span class="holiday-item-span">
                    {{ holiday.employee.name }} {{ holiday.employee.lastName }}
                  </span>
                </div>
                <div class="el-col-xs-24">
                  <span class="holiday-item-span">Solicitud: </span>{{ formatDateTime(holiday.timestamp) }}
                </div>
                <div class="el-col-xs-12">
                  <span class="holiday-item-span">Desde: </span>{{ formatDate(holiday.fromDate) }}
                </div>
                <div class="el-col-xs-12">
                  <span class="holiday-item-span">Hasta: </span>{{ formatDate(holiday.toDate) }}
                </div>
                <div class="el-col-xs-12">
                  <span class="holiday-item-span">Ejercicio: </span>{{ holiday.yearExercise }}
                </div>
                <div class="el-col-xs-12">
                  <span class="holiday-item-span">Días: </span>
                  <span class="denied"><b>{{ holiday.daysConsumed }}</b></span>
                </div>
                <div class="el-col-xs-24">
                  <span class="holiday-item-span">Responsable: </span>
                  {{
                    holiday.employee.teamManager != null
                      ? holiday.employee.teamManager.name + ' ' + holiday.employee.teamManager.lastName
                      : '--'
                  }}
                </div>
                <div class="el-col-xs-24" @click.stop>
                  <span class="holiday-item-span mt-1">Estado: </span>
                  <div class="holiday-select form-item mt-1">
                    <el-select v-model="holiday.status" placeholder="Estado"
                      :class="statusClassById(holiday.status)"
                      :disabled="isTerminalStatus(holiday.status)"
                      @change="specificHolidayStatusChange(index)">
                      <el-option v-for="item in filteredStatusOptions(holiday.status)" :key="item.value"
                        :label="item.label" :value="item.value">
                        <span :class="statusClass(item.label)">{{ item.label }}</span>
                      </el-option>
                      <template #tag>
                        <el-tag :style="{ color: 'blue' }" />
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-card>
          </el-row>
        </div>
      </div>
      <div v-else>
        <h5>No se han encontrado vacaciones según los filtros especificados...</h5>
      </div>
      <SharedElementPagination class="pagination" v-model:current-page="page"
        :total="totalResults" v-model:page-size="itemsPerPage" @change="page = $event; getHolidays()" show-always />
    </div>


    <!-- Ventana de confirmación de cambio de estado de unas vacaciones -->
    <HolidayStatusConfirmDialog :model-value="showStatusConfirmationModal"
      :employee-name="selectedHoliday.employee?.fullName || [selectedHoliday.employee?.name, selectedHoliday.employee?.lastName].filter(Boolean).join(' ')"
      :period="showStatusConfirmationModal ? moment(selectedHoliday.fromDate).format('DD/MM/YYYY') + ' – ' + moment(selectedHoliday.toDate).format('DD/MM/YYYY') : ''"
      :status="selectedHoliday.status || ''"
      :status-label="statusOptions.find(option => option.value === selectedHoliday.status)?.label || ''"
      :loading="confirmingStatus" @confirm="acceptStatusConfirmationModal"
      @update:model-value="closeStatusConfirmationModal" />

  </div>
</template>

<style lang="scss" scoped>
.holiday-employee {
  min-width: 0;

  > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  :deep(.media) {
    flex: 0 0 46px;
    width: 46px;
    height: 46px;
    aspect-ratio: 1;
  }

  :deep(.media img) {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    padding: 3px;
    background-color: #fff;
  }
}

.holidays-table {
  table {
    table-layout: fixed;
    width: 100%;
  }

  .holiday-name-column { width: 22%; }
  .holiday-request-column { width: 12%; }
  .holiday-date-column { width: 11%; }
  .holiday-year-column { width: 8%; }
  .holiday-days-column { width: 5%; }
  .holiday-status-column { width: 180px; }

  th,
  td {
    overflow-wrap: anywhere;
  }

  .holiday-select {
    margin-bottom: 0;

    .el-select {
      width: 100%;
      min-width: 0;
    }
  }
}

@media (min-width: 768px) and (max-width: 1440px) {
  .holidays-table {
    .holiday-status-column { width: 160px; }

    table th,
    table td {
      padding: 12px 8px;
    }

    table th {
      font-size: 16px;
    }

    .holiday-select :deep(.el-select__wrapper) {
      padding: 0 12px;
      font-size: 14px;
      gap: 6px;
    }
  }
}

.denied { color: #F9156F; }

.card-search {
  border-radius: 15px;
  background: white url("../../assets/images/camera.png") no-repeat;
  background-position-x: 100%;
  background-size: contain;
  overflow: visible !important;
}

.holidays {
  margin-bottom: 20px;
}

.pagination {
  padding: 0px 0px 20px 0px;
}

.holiday-toolbar-button { width: auto; min-width: 230px; max-width: 100%; padding: 9px 24px; margin-top: 15px; flex: 0 0 auto; }

.total-vacations {
  width: 320px;
  margin-top: 15px;
  color: $font-blue-color;
  padding: 0.5rem;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
}

.btn-new {
  margin-top: 30px;
}

.no-scroll-dialog .el-dialog__body {
  overflow-y: hidden !important;
}

.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;
  overflow-y: hidden !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

  .my-body {
    margin-right: 5%;
  }
}

@media(min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media(max-width: 767px) {
  // Quitar imagen fondo busqueda
  // .card-search {
  //   background: white;
  // }

  .holiday-toolbar-button { width: 100%; min-width: 0; }

  .buttons-holiday-admin {
    display: flex;
    justify-content: center;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    padding-right: 0;
    padding-left: 0;

    .card-holiday-item {
      width: 100%;
      padding: 10px 0px;
      border-radius: 16px;
      font-size: 15px;

      .holiday-item-span {
        color: $bg-blue;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .holiday-select {
        width: 100%;

        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
